import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/auth/auth-context";
import { ROUTE_PATHS } from "@/routing/domainRoutes";

export function ProtectedRoute({ children }: { children: JSX.Element }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return <div className="min-h-screen grid place-items-center text-sm text-muted-foreground">Loading session...</div>;
  }

  if (!user) {
    return <Navigate to={ROUTE_PATHS.login} replace state={{ from: location.pathname }} />;
  }

  return children;
}
